import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { ReportsService, ReportTypes, AlertReportsOptions } from 'src/share/services/reports';
import { StatisticsService, StatsTypes } from 'src/share/services/statistics';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import MonthlyFilter, { IMonthOption } from 'src/share/components/MonthlyFilter/MonthlyFilter';
import AgencyFilter from 'src/share/components/AgencyFilter/AgencyFilter';
import CircleChart from 'src/share/components/Chart/CircleChart';
import DatesChart from 'src/share/components/Chart/ChartDays';
import ChartBars from 'src/share/components/Chart/ChartBars';
import { formatNumber } from 'src/share/utils/formatNumbers';
import { IAlertsStatsMetrics, initalAlertsStatsMetrics } from 'src/share/types/alert';
import { closeCaseTypes, CloseCaseReason } from 'src/share/types/case/case';
import { IAuthState } from 'src/modules/Auth/store/types';
import { IReduxState } from 'src/reduxTypes';
import { getOptions } from 'src/share/utils/utils';
import { RoutesModules } from 'src/modules/Routing/types';
import ChartLoader from 'src/share/components/ChartLoader/ChartLoader';
import { YearLoader } from 'src/share/components/ChartLoader/YearLoader';
import { SexLoader } from 'src/share/components/ChartLoader/SexLoader';
import { AbductorLoader } from 'src/share/components/ChartLoader/AbductorLoader';
import { countUp } from 'src/modules/Dashboard/Global/components/CountUp';
import './alertsStats.css';

export interface IProvidersStatsProps {
  auth: IAuthState
}
export interface IProvidersStatsState {
  alertsStats: IAlertsStatsMetrics;
  agencyCode: string
  options: IMonthOption[]
  selected: IMonthOption
  loading: boolean;
}

export class AlertsStats extends React.Component<IProvidersStatsProps, IProvidersStatsState> {
  constructor(props: IProvidersStatsProps) {
    super(props);
    const options = getOptions()
    this.state = {
      options,
      selected: options[0],
      agencyCode: props.auth.agencyCode,
      alertsStats: initalAlertsStatsMetrics,
      loading: true
    }
  }
  public componentDidMount() {
    this.loadData();
  }
  public getReport = async (type) => {
    try {
      const { gte, lte } = this.state.selected;
      const filters = { agencyCode: this.state.agencyCode, range: { gte, lte } };
      await ReportsService.get(ReportTypes.ALERTS, type, filters);
    } catch (error) {
      toastr.error('Error', 'There was a problem getting the report');
    }
  }
  public async loadData() {
    try {
      const { agencyCode, selected: { gte, lte } } = this.state;
      const filters = { agencyCode, range: { gte, lte } };
      this.setState({ loading: true });
      const alertsStats: IAlertsStatsMetrics = await StatisticsService.getStats(StatsTypes.ALERTS, filters);
      this.setState({ alertsStats, loading: false });
    } catch (error) {
      toastr.error('Error', 'There was a problem loading the alerts stats');
      this.setState({ loading: false });
    }
  }
  public changeAgency = async (agencyCode) => {
    this.setState({ agencyCode }, () => this.loadData())
  }
  public changeMonth = async (selected: IMonthOption) => {
    this.setState({ selected }, () => this.loadData())
  }
  public render() {
    const { alertsStats: { day, country, open, closed, total, countries, avgImpresions, avgClicks, casesWithAlerts, stopReasons }, loading } = this.state;
    return (
      <div className="alerts-stats">
        <AgencyFilter changeAgency={this.changeAgency} showOnlyAdmin={false} loading={loading} />
        <MonthlyFilter changeSelected={this.changeMonth} options={this.state.options} selected={this.state.selected} />
        <Row>
          <Col className="col-12 totals">
            <Col className="col-12 content white-background">
              <Row>
                <Col xs={12} md={4}><h3>Issued Alerts: {!loading && <span>{countUp(total)}</span>}</h3></Col>
                <Col xs={12} md={4}><h3>Active Alerts: {!loading && <span>{countUp(open)}</span>}</h3></Col>
                <Col xs={12} md={4}><h3>Stopped Alerts: {!loading && <span>{countUp(closed)}</span>}</h3></Col>
                {countries > 0 && <Col xs={12} md={4}><h3>Countries: {!loading && <span>{countUp(countries)}</span>}</h3></Col>}
                <Col xs={12} md={4}><h3>Avg Impressions: {!loading && <span>{countUp(Math.round(avgImpresions * 10) / 10)}</span>}</h3></Col>
                <Col xs={12} md={4}><h3>Avg Clicks: {!loading && <span>{countUp(Math.round(avgClicks * 10) / 10)}</span>}</h3></Col>
                <Col xs={12} md={4}>
                  <h3>Alerted cases closed: {!loading && <span>{countUp(Math.round(casesWithAlerts.closedPercentage * 10) / 10)}%</span>}</h3>
                </Col>
                <Col xs={12} md={4}>
                  <h3>Avg Days to close an alerted case: {!loading && <span>{countUp(Math.round(casesWithAlerts.avgDaysToCloseACase * 10) / 10)}</span>}</h3>
                </Col>
              </Row>
            </Col>
          </Col>
        </Row>
        <Row>
          <Col className="col-12">
            <Col className="col-12 content white-background">
              <h3>
                Daily Impressions&nbsp;
                {!loading && day.imps.length > 0 &&
                  <span onClick={() => this.getReport(AlertReportsOptions.DAILY_IMPRESSIONS)} className="subOption">
                    (download)
                  </span>
                }
              </h3>
              <ChartLoader chart={DatesChart} loader={YearLoader} data={day.imps} dataKey={'Impressions'} strokePrimary={true} loading={loading} />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col className="col-12">
            <Col className="col-12 content white-background">
              <h3>
                Daily Clicks&nbsp;
                {!loading && day.clicks.length > 0 &&
                  <span onClick={() => this.getReport(AlertReportsOptions.DAILY_CLICKS)} className="subOption">
                    (download)
                  </span>
                }
              </h3>
              <ChartLoader chart={DatesChart} loader={YearLoader} data={day.clicks} dataKey={'Clicks'} loading={loading} />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col className="col-12">
            <Col className="col-12 content white-background">
              <h3>
                Cases with Alerts Issued&nbsp;
                {!loading && casesWithAlerts.total > 0 &&
                  <span onClick={() => this.getReport(AlertReportsOptions.ALERTED_CASES_CLOSED)} className="subOption">
                    (download)
                  </span>
                }
              </h3>
              <ChartLoader chart={CircleChart} loader={SexLoader} data={[{ name: 'closed', count: casesWithAlerts.closed }, { name: 'open', count: casesWithAlerts.open }]} loading={loading} />
              {casesWithAlerts.total > 0 && <h3>Total: {casesWithAlerts.total}</h3>}
              {casesWithAlerts.total === 0 && !loading && <p>No Data to Show</p>}
            </Col>
          </Col>
        </Row>
        <Row>
          <Col className="col-md-6 col-sm-12 col-xs-12">
            <Col className="col-12 imps content white-background">
              <h3>
                Country Impressions&nbsp;
                {!loading && country.imps.length > 0 &&
                  <span onClick={() => this.getReport(AlertReportsOptions.IMPRESSIONS_BY_COUNTRY)} className="subOption">
                    (download)
                  </span>
                }
              </h3>
              <ChartLoader chart={ChartBars} chartSyncId="countryImpsChart" loader={AbductorLoader} data={country.imps} loading={loading} />
            </Col>
          </Col>
          <Col className="col-md-6 col-sm-12 col-xs-12">
            <Col className="col-12  clicks content white-background">
              <h3>
                Country Clicks&nbsp;
                {!loading && country.clicks.length > 0 &&
                  <span onClick={() => this.getReport(AlertReportsOptions.CLICKS_BY_COUNTRY)} className="subOption">
                    (download)
                  </span>
                }
              </h3>
              <ChartLoader chart={ChartBars} chartSyncId="countryClicksChart" loader={AbductorLoader} data={country.clicks} loading={loading} />
            </Col>
          </Col>
        </Row>
        <Row>
          <Col className="col-12">
            <Col className="col-12 close-reasons content white-background">
              <h3>
                Stop alert's reasons&nbsp;
                {!loading && formatNumber(closed) > 0 &&
                  <span onClick={() => this.getReport(AlertReportsOptions.STOP_REASONS)} className="subOption">
                    (download)
                  </span>
                }
              </h3>
              <ChartLoader chart={CircleChart} loader={SexLoader} data={stopReasons.map(reason => ({ name: closeCaseTypes[CloseCaseReason[reason.name]], count: reason.count }))} loading={loading} />
              {formatNumber(closed) > 0 && !loading && <h3>Total: {countUp(closed)}</h3>}
              {formatNumber(closed) === 0 && !loading && <p>No Data to Show</p>}
            </Col>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});

export default SidebarContainer(RoutesModules.ALERTS)(connect(mapStateToProps)(AlertsStats));
